export const OTHER_MICROSOFT_SERVICES: readonly string[] = [
  'Azure',
  'Forms',
  'Microsoft Ads',
  'Microsoft Services Account (MSA)',
  'OneDrive Consumer (ODC)',
  'OneDrive for Business (ODB)',
  'Outlook Consumer Email',
  'Outlook Enterprise Email',
  'SharePoint Online',
  'Teams',
  'XBOX'
];
